"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInterest = void 0;
var UserInterest;
(function (UserInterest) {
    UserInterest["EDUCATION"] = "EDUCATION";
    UserInterest["HEALTH"] = "HEALTH";
    UserInterest["FAMILY_AND_COMMUNITY"] = "FAMILY_AND_COMMUNITY";
    UserInterest["BENEFITS"] = "BENEFITS";
    UserInterest["FINANCES"] = "FINANCES";
    UserInterest["ENVIRONMENT"] = "ENVIRONMENT";
    UserInterest["HERITAGE_AND_CULTURE"] = "HERITAGE_AND_CULTURE";
    UserInterest["TECHNOLOGY"] = "TECHNOLOGY";
    UserInterest["SPORTS_AND_RECREATION"] = "SPORTS_AND_RECREATION";
    UserInterest["HOUSING"] = "HOUSING";
    UserInterest["JOBS_BUSINESS_AND_ECONOMY"] = "JOBS_BUSINESS_AND_ECONOMY";
    UserInterest["PUBLIC_SAFETY_AND_SECURITY"] = "PUBLIC_SAFETY_AND_SECURITY";
    UserInterest["TRANSPORT_AND_TRAVEL"] = "TRANSPORT_AND_TRAVEL";
})(UserInterest || (exports.UserInterest = UserInterest = {}));
//# sourceMappingURL=user-interest.js.map